const getResults = (tabs, filter) => {
    const results = []
    tabs.forEach((tab) => {
        getLevelResults(results, tab.tree, tab, filter)
    })
    results.sort((a, b) => {
        return a.data.label > b.data.label ? 1 : a.data.label < b.data.label ? -1 : 0
    })
    return results
}
export default getResults

const getLevelResults = (results, items, tab, filter) => {
    items.forEach((item) => {
        if (item.children) {
            getLevelResults(results, item.children, tab, filter)
        }
        const isMatching = testIsMatching(item.label, filter)
        if (isMatching) {
            results.push({
                data: {
                    ...item,
                    label: `<b>${item.label}</b> (${tab.label})`
                },
                level: 0
            })
        }
    })
}

const testIsMatching = (label, filter) => {
    label = label
        .toLowerCase()
        .split('é')
        .join('e')
        .split('è')
        .join('e')
        .split('ê')
        .join('e')
        .split('à')
        .join('a')
        .split('â')
        .join('a')
        .split('ô')
        .join('o')
        .split('î')
        .join('i')
        .split('û')
        .join('u')

    filter = filter
        .toLowerCase()
        .split('é')
        .join('e')
        .split('è')
        .join('e')
        .split('ê')
        .join('e')
        .split('à')
        .join('a')
        .split('â')
        .join('a')
        .split('ô')
        .join('o')
        .split('î')
        .join('i')
        .split('û')
        .join('u')

    return label.indexOf(filter) > -1
}
